import { getJson } from './client';
import type { PricesResponse } from './types';
export const fetchPrices = () => getJson<PricesResponse>('/api/prices');
